import { axiosInstance, API_ENDPOINTS, getAuthHeaders } from '../config/api';
import { formatPrescriptionData } from '../utils/prescriptionFormatter';

export const createPrescription = async (consultationData) => {
  try {
    console.log('🔥 Creating prescription for appointment:', consultationData.appointment_id);
  console.log('🔥 Input consultation data:', JSON.stringify(consultationData, null, 2));

    const formattedPrescriptionData = formatPrescriptionData(consultationData);
    
    console.log('🔥 Formatted prescription data:', JSON.stringify(formattedPrescriptionData, null, 2));

    // const validation = validatePrescriptionData(formattedPrescriptionData);
    // if (!validation.isValid) {
    //   console.error('🔥 Prescription validation failed:', validation.errors);
    //   throw new Error(`Validation failed: ${validation.errors.join(', ')}`);
    // }

    const response = await axiosInstance.post(
      API_ENDPOINTS.PRESCRIPTION.CREATE,
      formattedPrescriptionData,
      { headers: getAuthHeaders() }
    );
    console.log('🔥 Prescription created successfully:', response.data);
    console.log(JSON.stringify(formattedPrescriptionData));
    return response.data;

  } catch (error) {
    console.error('🔥 Prescription creation error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });

    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Failed to create prescription'
    );
  }
};

export const handlePrescriptionCreation = async (consultationData, onSuccess, onError) => {
  try {
    const result = await createPrescription(consultationData);
    
    if (onSuccess) {
      onSuccess(result);
    }
    
    return true;
  } catch (error) {
    console.error('🔥 Prescription creation failed:', error);
    
    if (onError) {
      onError(error);
    }
    
    return false;
  }
};

export const prepareConsultationData = (rawData) => {
  console.log('🔥 prepareConsultationData - Raw input:', rawData);
  console.log('🔥 prepareConsultationData - Parameters from rawData.parameters:', rawData.parameters);
  console.log('🔥 prepareConsultationData - Clinical findings from rawData.clinicalFindingsData:', rawData.clinicalFindingsData);
  console.log('🔥 prepareConsultationData - Clinical findings from rawData.clinical_findings:', rawData.clinical_findings);
  
  // Ensure parameters is an object and log its contents
  const parameters = rawData.parameters || {};
  console.log('🔥 prepareConsultationData - Processed parameters:', parameters);
  
  // Normalize past history (accept legacy shapes)
  const sourcePastHistory = rawData.PastHistoryData || rawData.PastHistory || rawData.PastHistorydata || [];
  const normalizedPastHistory = Array.isArray(sourcePastHistory) ? sourcePastHistory.map((item, idx) => {
    if (!item) return null;
    const text = item.pasthistory || item.history || item.text || '';
    if (!text) return null;
    let pasthistory_no = item.pasthistory_no || item.history_no || '';
    if (!pasthistory_no) pasthistory_no = `H-${String(idx + 1).padStart(3,'0')}`;
    if (/^F/i.test(pasthistory_no)) pasthistory_no = pasthistory_no.replace(/^F-?/i, 'H-');
    const history_no = item.history_no || pasthistory_no.replace(/^H-(\d{3})$/i,'H$1');
    return {
      pasthistory_no,
      history_no,
      pasthistory: text,
      history: text,
      duration: item.duration || '',
      date: item.date || ''
    };
  }).filter(Boolean) : [];

  const preparedData = {
    ...rawData,
    complaints: rawData.complaints || [],
    diagnosis: rawData.diagnosis || [],
    medicinesData: rawData.medicinesData || rawData.medicines || [],
    advicesData: rawData.advicesData || rawData.advice || [],
    clinicalFindingsData: rawData.clinicalFindingsData || rawData.clinical_findings || [],
    clinical_findings: rawData.clinicalFindingsData || rawData.clinical_findings || [],
    PastHistoryData: normalizedPastHistory,
    allergies: rawData.allergies || {},
    investigationsList: rawData.investigationsList || [],
    parameters: parameters // Ensure parameters are included in the prepared data
  };
  
  console.log('🔥 prepareConsultationData - Final prepared data:', preparedData);
  console.log('🔥 prepareConsultationData - Final clinical findings:', preparedData.clinicalFindingsData);

  if (!preparedData.appointment_id && rawData.appointment_id) {
    preparedData.appointment_id = rawData.appointment_id;
  }

  if (!preparedData.followUpDate && !preparedData.nextVisitDate) {
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);
    preparedData.followUpDate = nextWeek.toISOString().split('T')[0];
  }

// Modify referred_to to match the new structure
  if (preparedData.referred_to) {
    preparedData.referred_to = [
      {
        referred_doctor_name: preparedData.referred_to.doctor_name || "",
        speciality: preparedData.referred_to.speciality || "",
        doctor_phone: preparedData.referred_to.phone || "",
        doctor_email: preparedData.referred_to.email || "",
        hospital: "City Hospital", // Assuming default values if not provided
        hospital_address: "123 Main St",
        phone: preparedData.referred_to.phone || "",
        email: preparedData.referred_to.email || "",
        date: new Date().toISOString().split('T')[0] // Current Date
      }
    ];
  }

  return preparedData;
};